import { ErrorResponse, SuccessResponse } from 'types/api';
import {
	ChangelogSchema,
	DeploymentType,
} from 'types/api/changelog/getChangelogByVersion';

// Upstream fetched its release notes from the vendor's CMS on every app load.
const getChangelogByVersion = async (
	_versionId?: string,
	_deploymentType?: DeploymentType,
): Promise<
	SuccessResponse<ChangelogSchema> | ErrorResponse
> => ({
	statusCode: 404,
	error: 'not available',
	message: null,
	payload: null,
});

export default getChangelogByVersion;
